interface ColorsType {
    primary: string;
    spinner: string;
    skeleton: string;

    ntClrOne: string;
    ntClrTwo: string;
    ntClrThree: string;

    primaryLight: string;
    primaryDark: string;

    text: string;
    subHeading: string;
    heading: string;

    btnDark: string;
    btnDarkHover: string;
    btnDarkActive: string;

    btnGrayDark: string;
    btnGrayDarkHover: string;
    btnGrayDarkActive: string;

    letterSpacing: string;
    borderRadius: string;
}

export const colors: ColorsType = {
    // Main Primary
    primary: "#86db48",
    spinner: "#86db48",
    skeleton: "#e6f7d9",

    // Neutral Colors (soft + agricultural friendly)
    ntClrOne: "#dfe6d8",
    ntClrTwo: "#f3fbea",
    ntClrThree: "#f8faf6",

    // Primary Palette
    primaryLight: "#9adf67",
    primaryDark: "#3f7224",

    // Text Colors
    text: "#3f4a3c",
    subHeading: "#2b3328",
    heading: "#182015",

    // Dark Button Colors (Primary Dark)
    btnDark: "#3f7224",
    btnDarkHover: "#579530",
    btnDarkActive: "#274f18",

    // Gray Button Colors (neutral, earthy)
    btnGrayDark: "#3a3f36",
    btnGrayDarkHover: "#4a5045",
    btnGrayDarkActive: "#2b2f28",

    // Values
    letterSpacing: "0.25px",
    borderRadius: "8px",
};

